module.exports = __webpack_public_path__ + "img/UltimateYogi.5303cf23.jpeg";